module.exports = __webpack_public_path__ + "img/shion yorigami_sc2.452fb552.png";